import { reportFrontendError } from './reportFrontendError';

let installed = false;

export function bootstrapFrontendErrors(applicationName: string): void {
  if (installed) {
    return;
  }
  installed = true;

  window.addEventListener('error', (event: ErrorEvent) => {
    void reportFrontendError({
      applicationName,
      eventType: 'unhandled_exception',
      message: event.message,
      stack: event.error?.stack ?? '',
      route: window.location.pathname,
      url: window.location.href,
      userAgent: window.navigator.userAgent,
    });
  });

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const message =
      event.reason instanceof Error ? event.reason.message : String(event.reason);
    const stack = event.reason instanceof Error ? event.reason.stack ?? '' : '';

    void reportFrontendError({
      applicationName,
      eventType: 'unhandled_rejection',
      message,
      stack,
      route: window.location.pathname,
      url: window.location.href,
      userAgent: window.navigator.userAgent,
    });
  });
}
